
const DataFactory = (props) => {
    const {
        content,
        type,
        classList,
        isAmp
    } = { ...props }
    console.log('DataFactory: ')
    console.log(content)
    return (
        //<iframe src="https://estadisticas.ellitoral.com/html/v3/model.html?channel=deportes.futbol.libertadores.608242&lang=es_LA&model=gamecast_v6&hidePagesMenu=true" width="100%" height="1150" scrolling="auto" style="width: 1px; min-width: 100%; *width: 100%;" class=""></iframe>
        <iframe 
            src={`${type.domain}?channel=${content.idCampeonato}.${content.idPartido}&lang=es_LA&model=gamecast_v6&hidePagesMenu=true`} 
            height="1150" 
            width="100%" 
            style={{ 
                width: '100%', 
                height: '1150px' 
            }} 
        />
    )
}

export default DataFactory;